import { Routes } from '@angular/router';

/**
 * Application routing configuration
 * Replaces ExtJS tab-based navigation with URL-based routing
 * Note: Authentication disabled - app starts directly at setup
 */
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'setup',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'setup',
        loadComponent: () => import('./features/setup/setup-layout/setup-layout.component').then(m => m.SetupLayoutComponent),
        children: [
          {
            path: '',
            redirectTo: 'event',
            pathMatch: 'full'
          },
          {
            path: 'event',
            loadComponent: () => import('./features/setup/event-setup/event-setup.component').then(m => m.EventSetupComponent)
          },
          {
            path: 'division',
            loadComponent: () => import('./features/setup/division-setup/division-setup.component').then(m => m.DivisionSetupComponent)
          },
          {
            path: 'weight',
            loadComponent: () => import('./features/setup/weight-setup/weight-setup.component').then(m => m.WeightSetupComponent)
          },
          {
            path: 'round',
            loadComponent: () => import('./features/setup/round-setup/round-setup.component').then(m => m.RoundSetupComponent)
          },
          {
            path: 'bracket',
            loadComponent: () => import('./features/setup/bracket-setup/bracket-setup.component').then(m => m.BracketSetupComponent)
          },
          {
            path: 'pools',
            loadComponent: () => import('./features/setup/pools-progressions/pools-progressions.component').then(m => m.PoolsProgressionsComponent)
          },
          {
            path: 'mat',
            loadComponent: () => import('./features/setup/mat-setup/mat-setup.component').then(m => m.MatSetupComponent)
          },
          {
            path: 'assignment',
            loadComponent: () => import('./features/setup/assignment-setup/assignment-setup.component').then(m => m.AssignmentSetupComponent)
          },
          {
            path: 'numbering',
            loadComponent: () => import('./features/setup/numbering/numbering.component').then(m => m.NumberingComponent)
          },
          {
            path: 'team-scoring',
            loadComponent: () => import('./features/setup/team-scoring/team-scoring.component').then(m => m.TeamScoringComponent)
          },
          {
            path: 'criteria',
            loadComponent: () => import('./features/setup/criteria-setup/criteria-setup.component').then(m => m.CriteriaSetupComponent)
          },
          {
            path: 'other-settings',
            loadComponent: () => import('./features/setup/other-settings/other-settings.component').then(m => m.OtherSettingsComponent)
          }
        ]
      },
      {
        path: 'queues',
        loadComponent: () => import('./features/queues/queues.component').then(m => m.QueuesComponent)
      },
      {
        path: 'bout-status',
        loadComponent: () => import('./features/bout-status/bout-status.component').then(m => m.BoutStatusComponent)
      },
      {
        path: 'data-management',
        loadComponent: () => import('./features/data-management/data-management-layout/data-management-layout.component').then(m => m.DataManagementLayoutComponent),
        children: [
          {
            path: '',
            redirectTo: 'wrestlers',
            pathMatch: 'full'
          },
          {
            path: 'wrestlers',
            loadComponent: () => import('./features/data-management/wrestlers/wrestlers.component').then(m => m.WrestlersComponent)
          },
          {
            path: 'teams',
            loadComponent: () => import('./features/data-management/teams/teams.component').then(m => m.TeamsComponent)
          },
          {
            path: 'users',
            loadComponent: () => import('./features/data-management/users/users.component').then(m => m.UsersComponent)
          },
          {
            path: 'import',
            loadComponent: () => import('./features/data-management/import/import.component').then(m => m.ImportComponent)
          }
        ]
      },
      {
        path: 'reports',
        loadComponent: () => import('./features/reports/reports-layout/reports-layout.component').then(m => m.ReportsLayoutComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./features/reports/reports-list/reports-list.component').then(m => m.ReportsListComponent)
          },
          {
            path: 'alive-wrestlers',
            loadComponent: () => import('./features/reports/alive-wrestlers/alive-wrestlers.component').then(m => m.AliveWrestlersComponent)
          },
          {
            path: 'bouts-per-hour',
            loadComponent: () => import('./features/reports/bouts-per-hour/bouts-per-hour.component').then(m => m.BoutsPerHourComponent)
          }
        ]
      },
      {
        path: 'announcer',
        loadComponent: () => import('./features/announcer/announcer.component').then(m => m.AnnouncerComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
